import { CreateCouponPlanScopeInterface } from '@spa/api';

import { CouponPlanScopeTypeEnum } from 'appShared/enums';

/**
 * Folds the two plan-scope pickers into the `plan_scopes` collection the coupon endpoints expect.
 *
 * The backend rejects a scope that sets both ids, so each selected plan becomes its own
 * `SpecificPlans` scope and each selected plan type its own `AllPlansOfType` scope. Both kinds may
 * be present on the same coupon.
 */
export const CouponPlanScopesFromControlValues = (
    tradingPlanIds: number[],
    tradingPlanTypeIds: number[]
): CreateCouponPlanScopeInterface[] => {
    const planScopes: CreateCouponPlanScopeInterface[] = (tradingPlanIds || [])
        .map((tradingPlanId: number) => ({
            plan_scope_type: CouponPlanScopeTypeEnum.SpecificPlans,
            trading_plan_id: tradingPlanId
        }));

    const planTypeScopes: CreateCouponPlanScopeInterface[] = (tradingPlanTypeIds || [])
        .map((tradingPlanTypeId: number) => ({
            plan_scope_type: CouponPlanScopeTypeEnum.AllPlansOfType,
            trading_plan_type_id: tradingPlanTypeId
        }));

    return [...planScopes, ...planTypeScopes];
};
